import { useOutletContext } from 'react-router-dom';
import ManageBillingButton from './ManageBillingButton';
import BillingLayout from './BillingLayout';

const BUTTON_CLASSES = "w-full h-12 bg-claraview-secondary hover:brightness-110 active:brightness-95 disabled:opacity-50 transition-all rounded-[3px] font-spaceMono text-[11px] tracking-[1.2px] text-claraview-quaternary uppercase";

const BillingUpdateCard = () => {
    const { statusError, retryStatus } = useOutletContext();

    return (
        <BillingLayout
            price={null}
            footerLabel="Status"
            footerValue="Past Due"
            footerTone="destructive"
            actions={
                <>
                    <ManageBillingButton label="Update Card" className={BUTTON_CLASSES} />

                    <p className="cv2-bill-reassurance mt-3.5 text-center font-aeonik text-xs normal-case">
                        256-bit encrypted checkout
                    </p>
                </>
            }
        >
            <div className="mb-10">
                <p className="cv2-bill-eyebrow font-spaceMono text-[10px] tracking-[1.4px] uppercase mb-4">
                    Account On Hold
                </p>
                <h2 className="font-aeonik font-normal text-[34px] sm:text-[40px] leading-[40px] sm:leading-[44px] tracking-[-0.9px] text-cv2-foreground normal-case">
                    Update Your<br />Payment Method
                </h2>
                <p className="cv2-bill-subcopy font-aeonik text-sm leading-[22px] mt-4 normal-case">
                    Your last payment didn't go through. Update your card to keep your account active.
                </p>
            </div>

            {statusError && (
                <div className="cv2-bill-error-banner text-sm border rounded-md px-3 py-2 mb-6">
                    {statusError} You can still try updating your card below.
                    <button type="button" onClick={retryStatus} className="block mt-1 underline underline-offset-2">
                        Retry
                    </button>
                </div>
            )}
        </BillingLayout>
    );
};

export default BillingUpdateCard;
